import React, { useEffect } from "react";
import { makeStyles, Theme, createStyles } from '@material-ui/core/styles';
import { Card, CardContent, CardMedia, Typography } from "@material-ui/core";
import { Link } from "react-router-dom";

const useStyles = makeStyles((theme: Theme) =>
  createStyles({
    card: {
      display: 'block',
      height: '100%',
      transition: "max-height 0.15s ease-out",
      border: '1px solid #ebdcc6',
      boxShadow: 'none',
    },
    title: {
      marginBottom: 2,
      minHeight: '36px',
      fontSize: '12px',
      fontWeight: 'bold',
      textAlign: 'center',
      color: 'black',
      lineHeight: 1.25,
    },
    media: {
      margin: 0,
      width: "100%",
      height: "245px",
      backgroundSize: "contain",
      [theme.breakpoints.down('sm')]: {
        height: "175px",
      },
    },
    content: {
      padding: "10px 12px 14px",
      "&:last-child": {
        paddingBottom: 14,
      },
    },
    link: {
      textDecoration: 'none'
    }
  }),
);

interface IProps {
  category: string,
  name: string,
  image: string
}

const ProductCategoryCard: React.FC<IProps> = ({
  category,
  name,
  image
}) => {
  useEffect(() => { }, []);

  const classes = useStyles();

  return (
    <Link to={'/product/category/' + category} className={classes.link}>
      <Card classes={{ root: classes.card }}>
        <CardMedia
          className={classes.media}
          image={process.env.REACT_APP_IMAGE_HOST+'/files/menu_pictures/' + image || ''}
        />
        <CardContent className={classes.content}>
          <Typography component="h3" className={classes.title}>
            {name || ''}
          </Typography>
        </CardContent>
      </Card>
    </Link>
  );
};

export default (ProductCategoryCard);
